import { compareAsc } from 'date-fns';
import { ChildEventProps, LocalizedDateTime } from './types';

export const eventIsSalesActive = (event: ChildEventProps) =>
    event &&
    (('is_sales_ended' in event && !event.is_sales_ended) ||
        !('is_sales_ended' in event));

export const eventIsAvailable = (event: ChildEventProps) =>
    event &&
    (('is_sold_out' in event && !event.is_sold_out) ||
        !('is_sold_out' in event));

export const findNextPurchasableEventFromDate = (
    date: LocalizedDateTime,
    childEvents: ChildEventProps[],
) => {
    const availableChildEvents = childEvents.filter(
        (event) => eventIsAvailable(event) && eventIsSalesActive(event),
    );

    const initialDate = new Date(date.local);
    const firstAvailableEvent = availableChildEvents.find(
        (event: ChildEventProps) =>
            compareAsc(new Date(event.start.local), initialDate) > 0,
    );

    return (
        firstAvailableEvent ??
        availableChildEvents[availableChildEvents.length - 1]
    );
};

export const findFirstPurchasableEvent = (
    childEvents: ChildEventProps[] | null,
) => {
    if (!childEvents) return null;
    const availableEvents: ChildEventProps[] = childEvents.filter(
        (event) => eventIsAvailable(event) && eventIsSalesActive(event),
    );
    return availableEvents[0] ?? null;
};

export const getEventChildById = (
    childEvents: ChildEventProps[] | null,
    eventId: string,
) => childEvents?.find((event) => event.id === eventId) || {};
